export default __webpack_public_path__ + "static/media/no-image.f6f26fa2.png";